// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YA2H","toggleWrap":"styles_toggleWrap__J5VEQ","content":"styles_content__334Zw","selectAreaCode":"styles_selectAreaCode__3xJTt"};